<template>
    <div class="table">
        <div class="container">
            <el-row>
                <el-button type="primary" @click="queryData">修改</el-button>
                <el-button type="primary" @click="closeEdit">关闭</el-button>
            </el-row>
            <div class="handle-box">
                <el-form :model="formData" :label-position="labelPosition" label-width="140px">
                    <el-row :gutter="16">
                        <el-col :span="8">
                            <el-form-item label="出库单号">
                                <el-input class="handle-input" v-model="formData.mateName" clearable></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="出库日期">
                                <el-input class="handle-input" v-model="formData.mateCode" clearable></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="订单编号">
                                <el-input class="handle-input" v-model="formData.mateName" clearable></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="16">
                        <el-col :span="8">
                            <el-form-item label="发出放库存节点名称">
                                <el-input class="handle-input" v-model="formData.mateCode" clearable></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="发出放库存节点编号">
                                <el-input class="handle-input" v-model="formData.mateCode" clearable></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="出库类型">
                                <el-select v-model="formData.mateCode" class="handle-input">
                                    <el-option key="1" label="满箱出库" value="满箱出库"></el-option>
                                    <el-option key="2" label="空箱出库" value="空箱出库"></el-option>
                                    <el-option key="3" label="维修出库" value="维修出库"></el-option>
                                    <el-option key="4" label="改制出库" value="改制出库"></el-option>
                                    <el-option key="5" label="报废出库" value="报废出库"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="16">
                        <el-col :span="8">
                            <el-form-item label="接受放库存节点名称">
                                <el-input class="handle-input" v-model="formData.mateName" clearable></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="接受放库存节点编号">
                                <el-input class="handle-input" v-model="formData.mateCode" clearable></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="流水号">
                                <el-input class="handle-input" v-model="formData.mateName" clearable></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
            </div>
            <el-tabs v-model="activeName" @tab-click="handleClick">
                <el-tab-pane label="出库清单" name="0">
                    <el-row :gutter="16">
                        <el-col :span="8">
                            <el-form :model="outForm" :label-position="labelPosition">
                                <el-form-item label="料架唯一编号">
                                    <el-input class="handle-input-out" v-model="outForm.mateCode" clearable></el-input>
                                </el-form-item>
                            </el-form>
                        </el-col>
                        <el-col :span="8">
                            <el-button type="primary" @click="queryData">查询</el-button>
                        </el-col>
                    </el-row>
                    <el-table :data="tableData" border highlight-current-row class="table">
                        <el-table-column show-overflow-tooltip prop="mateCode" label="料架类型编号"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="no" label="料架唯一编号"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="mateName" label="料架类型名称"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="createDate" label="料架状态"></el-table-column>
                    </el-table>
                </el-tab-pane>
                <el-tab-pane label="出库汇总" name="1">
                    <el-row class="action-btn">
                        <el-button type="primary" @click="addRow">新增</el-button>
                        <el-button type="primary" @click="delRow">删除</el-button>
                    </el-row>
                    <el-table :data="outStoreTable" border highlight-current-row class="table" @selection-change="handleSelectionChange">
                        <el-table-column type="selection" width="55"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="mateName" label="料架类型名称"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="no" label="料架类型编号"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="count" label="出库数量"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="rackName" label="改制料架类型名称"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="rackNo" label="改制料架类型编号"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="rackAround" label="改制料架类型编号号段"></el-table-column>
                    </el-table>
                </el-tab-pane>
            </el-tabs>
            <div class="pagination">
                <el-pagination  @current-change="handleCurrentChange" layout="prev, pager, next" :total="total"></el-pagination>
            </div>
        </div>
    </div>
</template>
<script>
    import router from '../../../../router'
    export default {
        name: 'out-store-order-edit',
        data() {
            return {
                tableData: [{
                    mateCode: '123456',
                    no: '00000000',
                    mateName: 'red',
                    createDate: '2019-09-09',
                    status: '9999'
                }],
                total: 0,
                labelPosition: 'right',
                formData: {
                    mateCode: '',
                    mateName: ''
                },
                activeName: '0',
                outForm: {
                    mateCode: ''
                },
                rowObj: {
                    mateName: '766578',
                    no: '122000',
                    count: 10,
                    rackName: '88990',
                    rackNo: 'No.39700-8',
                    rackAround: '1100-9900'
                },
                outStoreTable:[],
                selectedRows: [],
                addCount: 0
            }
        },
        created() {
            this.outStoreTable.push(this.rowObj);
        },
        methods: {
            queryData(){
                console.dir(this.queryCondition);
            },
            closeEdit(){
                router.replace({
                    path: './out-store-order'
                });
            },
            /**
             * 翻页事件
             */
            handleCurrentChange(){

            },
            downloadMatePart(){

            },
            handleClick(){

            },
            addRow(){
                this.addCount ++;
                let obj = {};
                Object.assign(obj,this.rowObj);
                obj.no += this.addCount;
                this.outStoreTable.push(obj);
            },
            handleSelectionChange(val){
                this.selectedRows = val;
            },
            delRow(){
                this.selectedRows.forEach((item)=>{
                    this.outStoreTable.forEach((obj,index) => {
                        if(obj.no == item.no){
                            this.outStoreTable.splice(index,1);
                        }
                    })
                })
            }
        }
    }
</script>
<style scoped>
    .handle-box{
        margin-top: 20px;
    }
    .handle-input{
        width: 85%;
    }
    .handle-input-out{
        width: 70%;
    }
    .action-btn{
        margin-bottom: 10px;
    }
</style>